/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
interface DiscoverIconProps {
    className?: string;
    width?: number | string;
    height?: number | string;
}

export default function DiscoverIcon(props: DiscoverIconProps) {
    return (
        <svg viewBox="0 0 38 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="0.5" y="0.5" width="37" height="21" rx="3.5" fill="white" />
            <rect x="4" y="2" width="30" height="18" rx="4" fill="white" />
            <path
                d="M11.2346 20H32.8001C33.4628 20 34 19.4638 34 18.8015V12.1094C34 12.1094 25.9599 17.5604 11.2346 20Z"
                fill="#E7772F"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.61743 8.33691H8.65832C9.80653 8.33691 10.6075 9.04957 10.6075 10.0756C10.6075 10.5881 10.362 11.0828 9.94826 11.4105C9.59994 11.6871 9.20253 11.8125 8.65198 11.8125H7.61743V8.33691ZM8.51632 11.2235C8.97479 11.2235 9.26149 11.1393 9.4867 10.9468C9.73053 10.7394 9.87705 10.4056 9.87705 10.0707C9.87705 9.73739 9.73053 9.41513 9.4867 9.20624C9.25049 9.00409 8.97479 8.92555 8.51632 8.92555H8.32608V11.2235H8.51632Z"
                fill="#1A1918"
            />
            <path d="M10.9341 8.33691H11.6399V11.8125H10.9341V8.33691Z" fill="#1A1918" />
            <path
                d="M13.3734 9.66876C12.9474 9.51924 12.8229 9.41964 12.8229 9.2318C12.8229 9.01346 13.0454 8.84788 13.3514 8.84788C13.5635 8.84788 13.7383 8.92911 13.9244 9.12762L14.2929 8.66502C13.9884 8.40863 13.624 8.27881 13.2268 8.27881C12.584 8.27881 12.0941 8.70672 12.0941 9.27255C12.0941 9.75296 12.3218 9.99668 12.9865 10.2281C13.2643 10.3205 13.4054 10.3837 13.4769 10.4265C13.6185 10.5141 13.689 10.6396 13.689 10.7846C13.689 11.0673 13.4549 11.2752 13.1385 11.2752C12.8016 11.2752 12.529 11.1138 12.3658 10.8107L11.9092 11.2339C12.2356 11.6916 12.627 11.8962 13.1661 11.8962C13.9014 11.8962 14.4195 11.4251 14.4195 10.7541C14.4195 10.2013 14.1792 9.95066 13.3734 9.66876Z"
                fill="#1A1918"
            />
            <path
                d="M14.6421 10.0755C14.6421 11.0976 15.4805 11.8896 16.5597 11.8896C16.8641 11.8896 17.1249 11.8321 17.4462 11.687V10.8883C17.1623 11.1613 16.9131 11.269 16.5907 11.269C15.8776 11.269 15.3724 10.7752 15.3724 10.0706C15.3724 9.40494 15.894 8.87757 16.5597 8.87757C16.8956 8.87757 17.1523 8.99146 17.4462 9.26851V8.47071C17.1358 8.32051 16.8811 8.2583 16.5742 8.2583C15.5012 8.2583 14.6421 9.06582 14.6421 10.0755Z"
                fill="#1A1918"
            />
            <path
                d="M23.1846 10.6703L22.2161 8.33691H21.4438L22.9835 11.9002H23.3633L24.9329 8.33691H24.1667L23.1846 10.6703Z"
                fill="#1A1918"
            />
            <path
                d="M25.2542 11.8125H27.2627V11.2235H25.9628V10.2854H27.2134V9.69663H25.9628V8.92555H27.2627V8.33691H25.2542V11.8125Z"
                fill="#1A1918"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.7825 8.33691C29.6003 8.33691 30.0668 8.71152 30.0668 9.36237C30.0668 9.89419 29.774 10.2432 29.24 10.3476L30.3827 11.8125H29.5113L28.5328 10.4151H28.4407V11.8125H27.7305V8.33691H28.7825ZM28.4406 9.93508H28.6463C29.1003 9.93508 29.3374 9.74805 29.3374 9.40016C29.3374 9.06158 29.1003 8.88385 28.6578 8.88385H28.4406V9.93508Z"
                fill="#1A1918"
            />
            <path
                d="M21.5437 10.0834C21.5437 11.084 20.6964 11.8951 19.6503 11.8951C18.6045 11.8951 17.7571 11.084 17.7571 10.0834C17.7571 9.08265 18.6045 8.27148 19.6503 8.27148C20.6964 8.27148 21.5437 9.08265 21.5437 10.0834Z"
                fill="#E7772F"
            />
            <rect x="0.5" y="0.5" width="37" height="21" rx="3.5" stroke="#DDDDDD" />
        </svg>
    );
}
